'use client';

import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import type { GTMEventGlycerinMarketingClick } from '@packages/tracking/src/types/events';
import { GlycerinMarketingType } from '@packages/tracking/src/types/enums';
import { usePaybackLink } from '../../shared/usePaybackLink';
import { SlotEquivalentLinksItem } from '../Base/SlotEquivalentLinks.Item.client';

export const PaybackLink = () => {
  const { href, label } = usePaybackLink();
  const { headerInformation, i18n } = useConfig();
  const dispatch = useTracking();

  const handleClick = () => {
    const language = i18n.defaultLocale.split('-')[0] as 'de' | 'fr' | 'en' | 'nl';
    const basePath = headerInformation?.[language]?.canonical;

    if (basePath) {
      const fullUrl = new URL(href, basePath).toString();
      dispatch<GTMEventGlycerinMarketingClick>({
        event: 'MarketingClick',
        MarketingClickData: {
          category: 'payback anmeldelayer',
          campaignType: 'kundenbindung',
          marketingType: GlycerinMarketingType.CAMPAIGN,
          label: 'payback-promo',
          target: fullUrl,
        },
      });
    }
  };

  return (
    <SlotEquivalentLinksItem href={href} onClick={handleClick}>
      <span className="icon-emp-payback-colored size-4" aria-hidden />
      <span className="hyphens-auto">{label}</span>
    </SlotEquivalentLinksItem>
  );
};
